import React from 'react';
import NavTagline from '../../../nav-tagline/nav-tagline';
import { Link } from 'react-router-dom';
import Footer from '../../../shared/Footer';
import { usePortalAuthentication } from '../../../../services/authorizationService';

const SuccessPreRegistration = () => {
    const { logout } = usePortalAuthentication();

    return (
        <div className="SuccessPreRegistration">
            <NavTagline />
            <section className="layout-container">
                <div className="container ctr">
                    <div className="bi-success-check">
                        <i className="bi bi-check2-circle" alt="Success Checkmark"></i>
                    </div>
                    <div className="lg-msg">
                        Registration is complete.
                    </div>
                    <div className="text-size6 spacer-margin3">
                        You are now authorized to access the portal.
                    </div>
                    <Link
                        onClick={(e) => {
                            e.preventDefault();
                            logout();
                        }}
                        className="btn btn-primary"
                        role="button"
                        aria-labelledby="Complete Registration">
                        Continue
                    </Link>
                </div>
            </section>
            <Footer />
        </div>
    )
};


export default SuccessPreRegistration;
